// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"styles_videoContainer__AT8Ab"};